import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardJump from '@swf/core/hooks/useWizardJump';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Update_details,
  TXTWCL_AlternativelyX_select_XTry_aga_ELL,
  TXTWCL_LetXs_try_that_againXX,
  TXTWCL_Please_check_your_informationX_ELL,
  TXTWCL_SorryX_we_were_unable_to_verif_ELL,
  TXTWCL_Try_again
} from './VerificationFailed.messages.json';

interface Props {
  onClose(): void;
}

const VerificationFailed: React.FC<Props> = ({ onClose }) => {
  const wizardJump = useWizardJump();
  const {
    values: { userLimitsSelect }
  } = useWizardContext();

  const retryLegalBoxesSave = () =>
    userLimitsSelect && userLimitsSelect.skipped
      ? wizardJump.jumpForward('#rmf.rmf-terms-of-service-without-limit-save')
      : wizardJump.jumpBack('#rmf.rmf-terms-of-service-save');

  const jumpToBeginningOfRMF = () => wizardJump.jumpBack('#rmf.rmf-legal-name');

  return (
    <Prompt
      onClose={onClose}
      variant="success"
      title={{ translation: TXTWCL_LetXs_try_that_againXX }}
      primaryButton={{ translation: TXTWCL_Try_again }}
      onPrimaryButtonClick={retryLegalBoxesSave}
      secondaryButton={{ translation: TXTCLI_Update_details }}
      onSecondaryButtonClick={jumpToBeginningOfRMF}
    >
      <Typography>
        <Translation {...TXTWCL_SorryX_we_were_unable_to_verif_ELL} />{' '}
        <Translation {...TXTWCL_Please_check_your_informationX_ELL} />{' '}
        <Translation {...TXTWCL_AlternativelyX_select_XTry_aga_ELL} />
      </Typography>
    </Prompt>
  );
};

export default VerificationFailed;
